module.exports = __webpack_public_path__ + "media/images/profile/6-8c7f638873b5ce48be31c9d25b4c6002.jpg";